import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetUser } from '../../contexts/user';
import { Button, ColContainer, RowContainer, Tab, Typography } from '../common';
import { Link } from 'react-router-dom';
import IconComponent from '../Icon';
import useClickOutside from '../../services/Helpers/useClickOutside';
import Avatar from '../User/Avatar';
import HelpCenter from '../HelpCenter';

const LOGO_IMAGE_CLASS = '/images/relay.png';

export const NavBar = () => {
    const router = useHistory();
    const [currentPath, setCurrentPath] = useState(router.location.pathname.split('/'));

    const { isAuthenticated, userNavItems, name, role } = useGetUser();

    router.listen((location) => {
        setCurrentPath(location.pathname.split('/'));
    });

    return (
        <RowContainer className="items-center z-30 fixed backdrop-filter backdrop-blur-lg justify-between h-20 px-12 shadow-header w-full">
            <RowContainer className="items-center gap-16 h-full flex-grow">
                <img className="h-10 mb-3" alt="ROI" src={LOGO_IMAGE_CLASS} />
                <RowContainer spacing="header" className="h-full">
                    {isAuthenticated && currentPath[1] !== 'login' ? (
                        userNavItems?.map((item) => {
                            return (
                                <Link to={item.route} key={item.id}>
                                    <Tab
                                        active={currentPath && `/${currentPath[1]}` === item.route}
                                    >
                                        {item.name}
                                    </Tab>
                                </Link>
                            );
                        })
                    ) : (
                        <></>
                    )}
                </RowContainer>
            </RowContainer>
            <HelpCenter />
            {isAuthenticated ? <User name={name} role={role} /> : <></>}
        </RowContainer>
    );
};

const User = ({ name, role }) => {
    const [isOpen, setIsOpen] = useState(false);
    const userDropdownRef = useRef(null);
    useClickOutside(userDropdownRef, setIsOpen);

    const logout = () => {
        localStorage.clear();
        window.location = "/login";
    };

    return (
        <div
            ref={userDropdownRef}
            className={`${isOpen && 'shadow-cards bg-white'} relative h-full z-50`}
        >
            <RowContainer
                spacing="medium"
                className={`z-50 h-full px-4 items-center cursor-pointer`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="border-2 border-brand-main flex-shrink-0 rounded-full">
                    <Avatar name={name} />
                </div>
                <ColContainer>
                    <Typography
                        variant="heading3.1"
                        color={isOpen && 'brand-main'}
                        className="transition-all"
                    >
                        {name}
                    </Typography>
                    <Typography variant="heading4">{role}</Typography>
                </ColContainer>
                <IconComponent
                    icon="chevron"
                    height={14}
                    width={14}
                    rotate={isOpen ? 180 : 0}
                    className={`${isOpen && 'text-brand-main'} transition-all ml-7`}
                />
            </RowContainer>
            <div
                className={`navbar-dropdown-menu ${
                    isOpen && 'open shadow-md'
                } absolute w-full px-4 rounded-b-xl bg-white z-30 `}
            >
                <Button type="link" onClick={logout}>
                    Logout
                </Button>
            </div>
        </div>
    );
};

export default NavBar;
